'use client';

import { useRouter } from 'next/navigation';

/**
 * Landing page Stripe redirects to when the user cancels checkout
 * (closes the tab, clicks "Back", etc.). No DB state has changed.
 */
export function BillingCancelPage() {
  const router = useRouter();
  return (
    <div
      style={{
        minHeight: 'calc(100vh - 56px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
      }}
    >
      <div
        style={{
          maxWidth: 460,
          width: '100%',
          background: 'var(--pm-paper)',
          border: '1px solid var(--pm-rule)',
          borderRadius: 16,
          padding: '36px 32px',
          textAlign: 'center',
        }}
      >
        <h1
          className="ad-serif"
          style={{
            margin: 0,
            fontSize: 26,
            fontWeight: 500,
            letterSpacing: -0.4,
            color: 'var(--pm-ink)',
          }}
        >
          Checkout cancelled
        </h1>
        <p
          style={{
            fontSize: 14,
            color: 'var(--pm-ink-3)',
            marginTop: 10,
            lineHeight: 1.55,
          }}
        >
          No charge was made. Your account stays on its current tier.
        </p>
        <div
          style={{
            display: 'flex',
            gap: 10,
            justifyContent: 'center',
            marginTop: 24,
          }}
        >
          <button
            type="button"
            onClick={() => router.push('/billing')}
            style={{
              padding: '10px 18px',
              borderRadius: 10,
              background: 'var(--pm-ink-fixed)',
              color: '#fff',
              border: '1px solid var(--pm-ink-fixed)',
              fontSize: 13.5,
              fontWeight: 500,
              cursor: 'pointer',
            }}
          >
            Back to billing
          </button>
          <button
            type="button"
            onClick={() => router.push('/monitoring')}
            style={{
              padding: '10px 18px',
              borderRadius: 10,
              background: 'var(--pm-paper)',
              color: 'var(--pm-ink)',
              border: '1px solid var(--pm-rule)',
              fontSize: 13.5,
              fontWeight: 500,
              cursor: 'pointer',
            }}
          >
            Continue without subscribing
          </button>
        </div>
      </div>
    </div>
  );
}
